import { Box, useTheme } from '@mui/material';
import {
  allExpanded,
  defaultStyles,
  darkStyles,
  JsonView,
} from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

export const JsonViewer = ({
  data,
}: {
  data: Parameters<typeof JsonView>[0]['data'];
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      className='px-[40px]'
      sx={{
        minHeight: '350px',
        maxHeight: '80%',
        overflow: 'auto',
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        '& *': {
          backgroundColor: 'transparent !important',
        },
        '& ul > div': {
          paddingLeft: '28px',
        },
        '& [role="treeitem"]': {
          lineHeight: '20px',
        },
        '& [role="button"]': {
          marginLeft: '-14px',
        },
      }}
    >
      <JsonView
        data={data}
        shouldExpandNode={allExpanded}
        style={{
          ...(isDarkMode ? darkStyles : defaultStyles),
        }}
      />
    </Box>
  );
};
